import { apiCall } from './gqlClient';
const GETHOLIDAYS_QUERY = "\n  query getHolidays {\n    getHolidays\n    {\n      id\n\t\t\tresourceId\n\t\t\tproviderId\n\t\t\tstartTime\n\t\t\tendTime\n\t\t\tdescription\n\t\t\tisWholeDay\n      ...fragments\n    }\n  }";
export const getHolidaysApiCall = async function () {
  let fragments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return apiCall({
    query: GETHOLIDAYS_QUERY,
    variables: {},
    fragments
  });
};
const GETRESOURCEHOLIDAYS_QUERY = "\n  query getResourceHolidays($resourceId: Int!) {\n    getResourceHolidays(resourceId: $resourceId)\n    {\n      id\n\t\t\tresourceId\n\t\t\tproviderId\n\t\t\tstartTime\n\t\t\tendTime\n\t\t\tdescription\n\t\t\tisWholeDay\n      ...fragments\n    }\n  }";
export const getResourceHolidaysApiCall = async function (_ref) {
  let {
    resourceId
  } = _ref;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETRESOURCEHOLIDAYS_QUERY,
    variables: {
      resourceId
    },
    fragments
  });
};
const REMOVERESOURCEFROMHOLIDAY_QUERY = "\n  mutation removeResourceFromHoliday($holidayId: Int!, $resourceId: Int!) {\n    removeResourceFromHoliday(holidayId: $holidayId, resourceId: $resourceId)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const removeResourceFromHolidayApiCall = async function (_ref2) {
  let {
    holidayId,
    resourceId
  } = _ref2;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: REMOVERESOURCEFROMHOLIDAY_QUERY,
    variables: {
      holidayId,
      resourceId
    },
    fragments
  });
};
const REMOVEHOLIDAY_QUERY = "\n  mutation removeHoliday($holidayId: Int!) {\n    removeHoliday(holidayId: $holidayId)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const removeHolidayApiCall = async function (_ref3) {
  let {
    holidayId
  } = _ref3;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: REMOVEHOLIDAY_QUERY,
    variables: {
      holidayId
    },
    fragments
  });
};
const SAVEHOLIDAY_QUERY = "\n  mutation saveHoliday($startTime: DateTime!, $endTime: DateTime!, $description: String!, $resources: [Int]) {\n    saveHoliday(startTime: $startTime, endTime: $endTime, description: $description, resources: $resources)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const saveHolidayApiCall = async function (_ref4) {
  let {
    startTime,
    endTime,
    description,
    resources
  } = _ref4;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: SAVEHOLIDAY_QUERY,
    variables: {
      startTime,
      endTime,
      description,
      resources
    },
    fragments
  });
};
const SAVEHOLIDAYREPEAT_QUERY = "\n  mutation saveHolidayRepeat($startTime: DateTime!, $endTime: DateTime!, $description: String!, $resources: [Int]) {\n    saveHolidayRepeat(startTime: $startTime, endTime: $endTime, description: $description, resources: $resources)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const saveHolidayRepeatApiCall = async function (_ref5) {
  let {
    startTime,
    endTime,
    description,
    resources
  } = _ref5;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: SAVEHOLIDAYREPEAT_QUERY,
    variables: {
      startTime,
      endTime,
      description,
      resources
    },
    fragments
  });
};
const EDITHOLIDAY_QUERY = "\n  mutation editHoliday($id: Int!, $startTime: DateTime!, $endTime: DateTime!, $description: String!, $resources: [Int], $modifyResources: Boolean) {\n    editHoliday(id: $id, startTime: $startTime, endTime: $endTime, description: $description, resources: $resources, modifyResources: $modifyResources)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const editHolidayApiCall = async function (_ref6) {
  let {
    id,
    startTime,
    endTime,
    description,
    resources,
    modifyResources
  } = _ref6;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: EDITHOLIDAY_QUERY,
    variables: {
      id,
      startTime,
      endTime,
      description,
      resources,
      modifyResources
    },
    fragments
  });
};